// extracted by mini-css-extract-plugin
export default {"newIconContainer":"NewSelectOption-module__newIconContainer--j5GGR","animatedBackground":"NewSelectOption-module__animatedBackground--03I1E"};